export default __webpack_public_path__ + "static/media/Bipolarized.278ef3ba.mp3";